/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.11.25",
    versionName: "0.2.0-nightly.2025.11.25",
    versionChannel: "nightly",
    buildDate: "2025-11-25T00:06:37.529Z",
    commitHash: "1b825cb5115ad287558f17812c4ddd81b268f3b6",
};
